// ** Redux Imports
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer' // assume it includes uiReducer
import { processingDelayMiddleware } from './processingDelayMiddleware'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(processingDelayMiddleware)
})

export { store }
